import { render, staticRenderFns } from "./ScreenLaudoRetorno.vue?vue&type=template&id=ff15278c&lang=true&"
import script from "./ScreenLaudoRetorno.vue?vue&type=script&lang=js&"
export * from "./ScreenLaudoRetorno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports